<template>
  <page>
    <div class="bg-color back-order">
      <div class="back-order-box">
        <div class="order-title">
          <h3 class="color-33 ft-14">商品信息</h3>
        </div>
        <div class="pic-box" v-for="(orderItem, index) in backRefundDto.refundGoods" :key="index">
          <img :src="orderItem.skuThumb" alt="" />
          <div class="card-msg">
            <p class="card-name">{{ orderItem.goodsName }}</p>
            <p class="card-num">
              ￥{{ orderItem.goodsPrice }} &nbsp;X &nbsp;{{ orderItem.number }}
            </p>
            <p class="card-date">
              <formatData
                class="time"
                :date="backRefundDto.addTime * 1000"
                fmt="yyyy-MM-dd hh:mm"
              />
              <span class="fr ft-14 color-orange">￥{{ orderItem.price }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="margin-t-10 back-order-box">
        <div class="order-title">
          <h3 class="color-33 ft-14">售后处理进度</h3>
        </div>
        <div class="progress-contain">
          <div class="steps">
            <template v-for="(item, index) in refundList">
              <template v-if="index !== 0">
                <div class="progress-line" :key="index + '_1'" v-if="item.isAct"></div>
              </template>
              <div class="eachStep" :key="index + '_2'" v-if="item.isAct">
                <img :src="item.status.img" alt="" />
                <div class="step-des">
                  <span class="ft-14">{{ item.status.text }}</span>
                  <span class="ft-12 step-name">{{ item.name }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="reback-reason margin-t-10" v-if="backRefundDto">
        <div class="order-title">
          <h3 class="color-33 ft-14">售后申请内容</h3>
        </div>
        <div class="reback-content">
          <van-cell title="售后类型" :value="refundTypeDesc" />
          <van-cell
            title="售后数量"
            :value="backRefundDto.refundGoods ? `${backRefundDto.refundGoods[0].number}个` : ''"
          />
          <van-cell title="售后金额" :value="backRefundDto.money" />
          <p class="ft-12 tips">温馨提示：退款时，退款金额将根据支付路径原路退回，请注意查收！</p>
        </div>
      </div>
      <div class="reback-reason margin-t-10" v-if="backRefundDto">
        <div class="reback-content">
          <van-cell
            title="协商历史"
            is-link
            @click="
              $router.push({
                name: 'back-history',
                query: { refundCode: backRefundDto.refundCode, sourceFlag: sourceFlag }
              })
            "
          />
        </div>
      </div>
      <div class="reback-reason margin-t-10" v-if="backRefundDto.refundType === '2'">
        <div class="order-title">
          <h3 class="color-33 ft-14">换货收件信息</h3>
        </div>
        <div class="reback-content">
          <van-cell title="收件人姓名" :value="businessDeliveryInfo.receiver" />
          <van-cell title="收件人电话" :value="businessDeliveryInfo.phone" />
          <p class="userAdd ft-12">
            <span class="ft-14 color-3232">收件地址:</span>
            {{ businessDeliveryInfo.address }}
          </p>
        </div>
      </div>
      <!--  售后进度：1:待进行 2:进行中 3:已完成 4:不通过 5:已取消 6:已失效 -->
      <!-- convertStatus 1：商家审核 2：商家收货确认 3：换货发出 4：退款 -->
      <div
        class="reback-reason margin-t-10"
        v-if="
          backRefundDto.refundType !== '3' &&
          (backRefundDto.convertStatus != 1 ||
            (backRefundDto.convertStatus == 1 && backRefundDto.convertProgressStatus != 2))
        "
      >
        <div class="order-title">
          <h3 class="color-33 ft-14">售后收件信息</h3>
        </div>
        <div class="reback-content">
          <van-cell title="商家收件人" :value="businessDeliveryInfo.receiver" />
          <van-cell title="商家收件电话" :value="businessDeliveryInfo.phone" />
          <p class="userAdd ft-12">
            <span class="ft-14 color-3232">商家收货地址</span>
            {{ businessDeliveryInfo.address }}
          </p>
          <p class="ft-12 note">
            备注：请将申请售后的商品及包装内附件等一并装盒寄回以上商家提供的售后地址
          </p>
        </div>
      </div>
      <div class="express-info-box margin-t-10" v-if="userDeliveryInfo.trackNumber">
        <div class="express-info-box--title">
          您寄回的物流信息
          <ClickCopy :content="`${userDeliveryInfo.trackNumber}`">复制单号</ClickCopy>
        </div>
        <van-cell title="您寄回的物流信息" />
        <van-cell title="寄件公司" :value="userDeliveryInfo.expressName" />
        <van-cell title="物流单号" :value="userDeliveryInfo.trackNumber" />
      </div>
      <div class="express-info-box margin-t-10" v-if="businessDeliveryInfo.trackNumber">
        <div class="express-info-box--title">
          商家换货的物流信息
          <ClickCopy :content="`${businessDeliveryInfo.trackNumber}`">复制单号</ClickCopy>
        </div>
        <van-cell title="寄件公司" :value="businessDeliveryInfo.expressName" />
        <van-cell title="物流单号" :value="businessDeliveryInfo.trackNumber" />
      </div>
      <div class="express-info-box margin-t-10" v-if="expressInfo">
        <van-cell title="请填写您寄回的物流信息" />
        <van-field
          readonly
          clickable
          label="寄件公司"
          :value="fillForm.expressCom.name"
          placeholder="点击选择寄件公司"
          @click="showExpressDialog = true"
        />
        <van-popup v-model="showExpressDialog" position="bottom" :style="{ height: '45%' }">
          <van-picker
            :columns="expressList"
            show-toolbar
            value-key="name"
            @cancel="showExpressDialog = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <van-field
          v-model="fillForm.trackingNumber"
          label="物流单号"
          placeholder="请填写物流单号"
        />
      </div>
      <div class="online-tips">
        <span>
          售后过程中有任何问题可咨询在线客服
          <br />
          或拨打客服热线：0755-27357035
        </span>
      </div>
      <div class="submit-box" v-if="expressInfo">
        <van-button type="danger" @click="handleSubmitExpressInfo" class="submit-btn">
          提交
        </van-button>
      </div>
    </div>
  </page>
</template>
<script>
import { mapState } from 'vuex'
import ClickCopy from '@/components/ClickCopy'
import formatData from '@/components/formatData'
export default {
  components: {
    formatData,
    ClickCopy
  },
  data() {
    return {
      businessDeliveryInfo: {},
      userDeliveryInfo: {},
      sourceFlag: '',
      showTypeSheet: false,
      showReasonSheet: false,
      showExpressDialog: false,
      exchangeExpressName: null,
      brief: '',
      goodsId: '',
      orderGoodsId: '',
      orderSn: '',
      ecsGoodsDto: {},
      orderInfo: {},
      reason: '商品破碎',
      typeReason: '退款',
      orderStatus: '',
      addressId: '',
      refundType: '',
      fillForm: {
        expressCom: '',
        trackingNumber: ''
      },
      convertProgressStatus: '', // 售后进度：1:待进行 2:进行中 3:已完成 4:不通过 5:已取消 6:已失效
      convertStatus: '', // 售后状态：1：商家审核 2：商家收货确认 3：换货发出 4：退款
      backRefundDto: {},
      type: '',
      refundList: [],
      progressStatus3: null,
      refundTypeDesc: null,
      refundOption: ['退货', '换货', '退款', '维修'],
      refundProgressUrl: [],
      convertProgressText: [],
      // convertProgressStatusOpion: ['待进行', '进行中', '已完成', '不通过', '已取消', '已失效'],
      goodsReceiver: '',
      goodsReceiverPhone: '',
      goodsAddress: '',
      expressInfo: false,
      expressList: [], // 快递公司列表
      number: null,
      isSubmit: false
    }
  },
  methods: {
    onConfirm(picker) {
      this.fillForm.expressCom = picker
      this.showExpressDialog = false
    },
    viewBackRefund() {
      const params = {
        refundCode: this.refundCode,
        orderGoodsId: this.orderGoodsId
      }
      const serviceF = params.orderGoodsId
        ? 'viewBackRefundByOrderGoodsId'
        : 'viewBackRefundByRefundCode'
      this.$service[serviceF](params).then((res) => {
        const data = res.data
        this.sourceFlag = data.sourceFlag
        const backRefundDto = data.backRefund
        this.backRefundDto = backRefundDto
        let reExprssList = this.backRefundDto.refundExpressList
        for (let i = 0, j = 0; i < reExprssList.length, j < reExprssList.length; i++, j++) {
          if (reExprssList[i].addressType === 2 && reExprssList[i].category === 1) {
            this.businessDeliveryInfo = reExprssList[i]
          }
          if (reExprssList[j].addressType === 1 && reExprssList[j].category === 2) {
            this.userDeliveryInfo = reExprssList[j]
          }
        }
        this.refundTypeDesc = this.refundOption[backRefundDto.refundType - 1]
        this.expressList = data.express.map((item) => {
          const exchangeExpressCode = backRefundDto.exchangeExpressCode
          if (exchangeExpressCode) {
            if (item.shippingCode === exchangeExpressCode) {
              this.exchangeExpressName = item.shippingName
            }
          }
          return {
            name: item.shippingName,
            code: item.shippingCode
          }
        })
        // res.data.express.forEach(item => this.expressList.push(item.shippingName))

        // 售后进度状态展示
        const convertStatus = parseInt(backRefundDto.convertStatus) // 1：商家审核 2：商家收货确认 3：换货发出 4：退款
        const refundType = parseInt(backRefundDto.refundType) // 1退货(1,2,4)，2换货(1,2,3)，3退款（1，4）
        const convertProgressStatus = parseInt(backRefundDto.convertProgressStatus) // 1:待进行 2:进行中 3:已完成 4:不通过 5:已取消 6:已失效
        const status = {
          1: {
            text: '待进行',
            img: require('@/assets/backOrder/check-white.png')
          },
          2: {
            text: '进行中',
            img: require('@/assets/backOrder/wait-red.png')
          },
          3: {
            text: '已完成',
            img: require('@/assets/backOrder/check-red.png')
          },
          4: {
            text: '不通过',
            img: require('@/assets/backOrder/cross-red.png')
          },
          5: {
            text: '已取消',
            img: require('@/assets/backOrder/cross-red.png')
          },
          6: {
            text: '已失效',
            img: require('@/assets/backOrder/cross-red.png')
          }
        }
        // 1：商家审核 2：商家收货确认 3：换货发出 4：退款
        this.refundList = [
          {
            name: '商家审核',
            isAct: true,
            status: convertStatus === 1 ? status[convertProgressStatus] : status['3']
          },
          {
            name: '商家收货确认',
            isAct: refundType !== 3,
            status:
              convertStatus === 2
                ? status[convertProgressStatus]
                : convertStatus > 2
                  ? status['3']
                  : status['1']
          },
          {
            name: '换货发出',
            isAct: refundType === 2,
            status:
              convertStatus === 3
                ? status[convertProgressStatus]
                : convertStatus > 3
                  ? status['3']
                  : status['1']
          },
          {
            name: '退款',
            isAct: refundType !== 2,
            status: convertStatus === 3 ? status[convertProgressStatus] : status['1']
          }
        ]
        // 退货或者换货且 商家审核已完成时
        if (refundType === 1 || refundType === 2) {
          if (convertStatus === 1 && convertProgressStatus === 3) {
            this.expressInfo = true
          }
        }
      })
    },
    handleSubmitExpressInfo() {
      if (this.isSubmit) return
      this.isSubmit = true
      const trackingNumber = this.fillForm.trackingNumber
      if (!/^[0-9a-zA-Z]*$/.test(trackingNumber)) {
        this.$toast('请请写正确的快递单号！')
        return false
      }
      const _express = this.expressList.find((item) => item.code === this.fillForm.expressCom.code)
      this.$service.saveBackRefundExpress({
        expressCode: this.fillForm.expressCom.code,
        expressName: _express.name,
        orderCode: this.backRefundDto.orderCode,
        refundCode: this.backRefundDto.refundCode,
        trackingNumber: trackingNumber,
        sourceFlag: this.sourceFlag
      }).then((res) => {
        if (res.code === 200) {
          this.$toast('提交成功!')
          window.location.reload()
        }
      })
    }
    // goBack() {
    //   this.$router.replace({
    //     name: 'order-detail',
    //     query: {
    //       orderSn: this.$route.query.orderSn
    //     }
    //   })
    // // replace替换原路由，作用是避免回退死循环
    // }
  },
  // destroyed() {
  //   if (this.$route.query.returnType) window.removeEventListener('popstate', this.goBack, false)
  // },
  mounted() {
    const queryData = this.$route.query
    this.orderGoodsId = queryData.orderGoodsId
    this.refundCode = queryData.refundCode
    this.type = queryData.type

    this.viewBackRefund()
    // if (window.history && window.history.pushState && queryData.returnType) {
    //   history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', this.goBack, false)
    // }
  },
  // 如果是退款页进来时，将默认返回
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     if (from.name === 'back-order') {
  //     }
  //   })
  // },
  computed: mapState({
    listenFlag: (state) => state.listenFlag
  })
}
</script>
<style lang="stylus" scoped>
h3 {
  margin: 0;
}

.back-order {
  overflow: hidden;
}

.back-order-box {
  background: #fff;
}

.pic-box {
  height: 79px;
  padding: 10px 15px;
  border-bottom: 1px solid #e5e5e5;
}

.pic-box img {
  width: 80px;
  height: 80px;
  float: left;
  background: #eee;
}

.pic-box .card-msg {
  margin-left: 10px;
  float: left;
  width: 255px;
  position: relative;
  height: 80px;
}

.card-msg .card-name {
  color: #333;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
}

.card-msg .card-num {
  color: #666;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
}

.card-msg .card-date {
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

.card-msg .card-date .time {
  color: #999;
  float: left;
}

.card-msg .card-date .pic-price {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  float: right;
}

.order-title {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  color: #999;
  position: relative;
}

.steps {
  display: -webkit-flex;
  display: flex;
  padding: 0 20px 18px 20px;
  flex-direction: row;
  justify-content: center;
  overflow: hidden;
  // width 375px
}

.steps .eachStep {
  text-align: center;
  padding-top: 18px;
  width: 300px;
}

.eachStep img {
  width: 42px;
  height: 42px;
}

.eachStep .step-des {
  text-align: center;
  font-size: 14px;
}

.step-des .step-name {
  color: #999999;
}

.progress-line {
  width: 175px;
  height: 1px;
  background: #D8D8D8;
  margin-top: 39px;
}

.progress-line2 {
  width: 53px;
  height: 1px;
  background: #D8D8D8;
  margin-top: 39px;
}

.lineActive {
  background: #FF3400;
}

.step-des span {
  display: block;
}

.tips {
  color: #999999;
  background: #fff;
  margin: 0;
  padding: 10px 10px;
}

.note {
  color: #FC4C00;
  background: #fff;
  margin: 0;
  padding: 0px 10px 10px;
}

.reback-reason {
  background: #fff;
}

.userAdd {
  color: #666;
  padding: 10px 10px 10px 15px;
  border-bottom: 1px solid #EFEFF4;
}

.online-tips {
  margin: 30px 0;
  font-size: 12px;
  color: #B2B2B2;
  text-align: center;
}

.submit-box {
  text-align: center;
}

.submit-box .submit-btn {
  width: 335px;
  background: #FF3400;
  border-radius: 8px 8px;
  margin-bottom: 20px;
}

.express-info-box--title {
  line-height: 44px;
  height: 44px;
  font-size: 14px;
  background: #ffffff;
  padding: 0 15px;
  border-bottom: 1px solid rgba(235, 237, 240, 0.5);
}
</style>
